// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1Ye3T","right":"styles_right__aR656"};